<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/admin/dashboard"
          :class="getRoute() === 'Dashboard' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Inicio'"
        >
          <template v-slot:icon>
            <i
              :class="getRouteI() === 'dashboard' ? 'i' : ''"
              class="bi bi-speedometer2 text-lg"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/admin/pacientes"
          :class="getRoute() === 'Dashboard' ? 'active' : ''"
          navText="Pacientes"
        >
          <template v-slot:icon>
            <i
              :class="getRouteI() === 'pacientes' ? 'i' : ''"
              class="bi bi-music-player text-lg"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/admin/pets"
          :class="getRoute() === 'Dashboard' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Pets'"
        >
          <template v-slot:icon>
            <i
              :class="getRouteI() === 'pets' ? 'i' : ''"
              class="bi bi-mic-fill text-lg"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          url="/admin/entrevista-social"
          :class="getRoute() === 'tables' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الجداول' : 'Entrevista Social'"
        >
          <template v-slot:icon>
            <div>
              <i
                :class="getRouteI() === 'entrevista-social' ? 'i' : ''"
                class="bi bi-journal-bookmark-fill text-lg"
              ></i>
            </div>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/admin/cooperadores"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Cooperadores'"
        >
          <template v-slot:icon>
            <i
              :class="getRouteI() === 'cooperadores' ? 'i' : ''"
              class="bi bi-people-fill text-lg"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/admin/medicos"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Médicos'"
        >
          <template v-slot:icon>
            <i
              :class="getRouteI() === 'medicos' ? 'i' : ''"
              class="bi bi-hospital text-lg"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/admin/patologias"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Patologias'"
        >
          <template v-slot:icon>
            <i
              :class="getRouteI() === 'patologias' ? 'i' : ''"
              class="bi bi-activity text-primary text-lg opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/admin/tipos-oleos"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Tipos de Óleos'"
        >
          <template v-slot:icon>
            <i
              :class="getRouteI() === 'tipos-oleos' ? 'i' : ''"
              class="bi bi-droplet text-primary text-lg opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/admin/relatorios"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Relatórios'"
        >
          <template v-slot:icon>
            <i
              :class="getRouteI() === 'relatorios' ? 'i' : ''"
              class="bi bi-file-earmark text-lg"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/admin/usuarios"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '' : 'Usuários'"
        >
          <template v-slot:icon>
            <i
              :class="getRouteI() === 'usuarios' ? 'i' : ''"
              class="bi bi-person text-lg"
            ></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
    };
  },
  components: {
    SidenavItem,
    SidenavCard,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    getRouteI() {
      const routeArr = this.$route.path.split("/");
      return routeArr[2];
    },
  },
};
</script>
<style scoped>
.navbar-vertical.bg-white .navbar-nav > .nav-item .nav-link.active {
  background-color: #16524e;
  color: #fff;
}

.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link i {
  margin-top: -8px;
}

i {
  color: #000 !important;
}

.i {
  color: #fff !important;
}
.icon-shape i {
  opacity: 1 !important;
}
</style>
